import { Injectable } from '@angular/core';
import { BaseHttpApiService } from './base-http.service';
import { HttpClient } from '@angular/common/http';
import { DateFormatHelperService } from './date-format-helper.service';
import { FirstHydroInstructionsGridDto } from '../Dtos/fhc-hydro/instructions-grid-dto';
import { Observable } from 'rxjs';
import { FirstHydroInstructionDto } from '../Dtos/fhc-hydro/instructions-dto';

@Injectable({
  providedIn: 'root'
})
export class FhcHydroService extends BaseHttpApiService{

  constructor(private httpClient: HttpClient,
    private dateHelper: DateFormatHelperService) { super(); }

    GetActiveAndFutureInstructions(): Observable<FirstHydroInstructionsGridDto[]> {
      return this.httpClient.get<FirstHydroInstructionsGridDto[]>(`${this.apiURL}FirstHydro/Instructions`);
    }
  
    GetInstructionsByDateRange(from: Date, to: Date): Observable<FirstHydroInstructionsGridDto[]> {
      return this.httpClient.get<FirstHydroInstructionsGridDto[]>(`${this.apiURL}FirstHydro/Instructions/${this.dateHelper.GetAPIFormat(from)}/${this.dateHelper.GetAPIFormat(to)}`);
    }
  
    GetInstructionById(instructionId:number|string): Observable<FirstHydroInstructionDto>{
      return this.httpClient.get<FirstHydroInstructionDto>(`${this.apiURL}FirstHydro/${instructionId}`)
    }

    SaveInstruction(instruction: FirstHydroInstructionDto) {
      return this.httpClient.post<object>(`${this.apiURL}FirstHydro`, instruction);
    } 
    ChangeStatus(instructionId:number|string, status: string){
      return this.httpClient.put<object>(`${this.apiURL}FirstHydro/SetStatus?instructionId=${instructionId}&status=${status}`,'') 
    }
}
